import { Component, Input, Type } from '@angular/core';
import { BaseModalDialogDirective } from 'src/app/shared/directives/base-modal-dialog.directive';
import { ModalSize } from 'src/app/shared/enums/modal-size.enum';
import { ModalCloseType } from 'src/app/shared/components/modal/modal-close-type.enum';

@Component({
  selector: 'app-generic-modal-wrapper',
  templateUrl: './generic-modal-wrapper.component.html',
  styleUrl: './generic-modal-wrapper.component.scss',
  standalone: false,
})
export class GenericModalWrapperComponent extends BaseModalDialogDirective {
  // INPUTS
  @Input() modalTitle: string;
  @Input() modalSize: ModalSize = ModalSize.Large;
  @Input() modalCloseType: ModalCloseType = ModalCloseType.Safe;
  @Input() contentComponent: Type<any>;
  @Input() contentInputs: Record<string, any>;
  @Input() customModalClass = 'no-padding'; // has to befined on root level or modal.component.scss

  // GETTERS
  get size(): ModalSize {
    return this.modalSize;
  }

  get closeType(): ModalCloseType {
    return this.modalCloseType;
  }

  get modalClass(): string {
    return this.customModalClass;
  }
}
